<template>
  <div>
    <button 
      v-if="activityStatus === activityStatuses.INVALID"
      v-b-tooltip="{
        title: tooltipMessages,
        container: 'body',
        boundary: 'viewport',
        trigger: 'focus',
        html: true,
        template: tooltipInvalidTemplate,
        placement: 'topright'
      }"
      class="other-img error-icon cursor-pointer text-error tooltip-btn">
      <i class="fas fa-exclamation-triangle pulse" aria-hidden="true"></i>
    </button>

    <span 
      v-if="activityStatus === activityStatuses.NOT_SYNCED"
      v-b-tooltip="{
        title: tooltipMessages,
        container: 'body',
        boundary: 'viewport',
        trigger: 'hover',
        template: tooltipTemplate,
        placement: 'topright'
      }"
      class="other-img error-icon cursor-pointer text-error">
      <i class="fas fa-chain-broken" aria-hidden="true"></i>
    </span>

    <span 
      v-if="activityStatus === activityStatuses.NOT_PROCESSED"
      v-b-tooltip="{
        title: tooltipMessages,
        container: 'body',
        boundary: 'viewport',
        trigger: 'hover',
        template: tooltipTemplate,
        placement: 'topright'
      }"
      class="other-img error-icon cursor-pointer text-error">
      <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    </span>

    <span 
      v-if="activityStatus === activityStatuses.FAILED"
      v-b-tooltip="{
        title: tooltipMessages,
        container: 'body',
        boundary: 'viewport',
        trigger: 'hover',
        template: tooltipTemplate,
        placement: 'topright'
      }"
      class="other-img error-icon cursor-pointer text-error">
      <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
    </span>

    <span 
      v-if="activityStatus === activityStatuses.BELT_NOT_WORN"
      v-b-tooltip="{
        title: tooltipMessages,
        container: 'body',
        boundary: 'viewport',
        trigger: 'hover',
        template: tooltipTemplate,
        placement: 'topright'
      }"
      class="other-img error-icon cursor-pointer text-error">
      <i class="fas fa-user-times" aria-hidden="true"></i>
    </span>
  </div>
</template>

<script>
import { ACTIVITY_STATUS } from '@/constants/SessionConsts'

export default {
  name: 'PlayerInvalidActivityIcon',
  props: [
    'activityStatus',
    'activityType'
  ],
  data () {
    return {
      activityStatuses: ACTIVITY_STATUS,
      tooltipTemplate: '<div class="tooltip event-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      tooltipInvalidTemplate: '<div class="tooltip event-tooltip tooltip-invalid" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    }
  },
  computed: {
    tooltipMessages : function() {
      switch (this.activityStatus) {
        case this.activityStatuses.INVALID:
          return `${this.$t('CALENDAR.invalidTooltipMessages.invalid')} <a href="javascript:ZohoHCAsap.kbArticles.view( { articleId : '316220000000446307' } );" title="See article">${this.$t('CALENDAR.invalidTooltipMessages.seeArticle')}</a>`
        case this.activityStatuses.NOT_SYNCED:
          if (this.activityType === "INDIVIDUAL") {
            return this.$t('CALENDAR.invalidTooltipMessages.notSyncedPMA');
          } else {
            return this.$t('CALENDAR.invalidTooltipMessages.notSyncedCMA');
          }
          // return this.$t('CALENDAR.invalidTooltipMessages.notSynced');
        case this.activityStatuses.NOT_PROCESSED:
          return this.$t('CALENDAR.invalidTooltipMessages.notProcessed');
        case this.activityStatuses.FAILED:
          return this.$t('CALENDAR.invalidTooltipMessages.failed');
        case this.activityStatuses.BELT_NOT_WORN:
          return this.$t('CALENDAR.invalidTooltipMessages.notWorn');
        case this.activityStatuses.TOO_LONG:
          return this.$t('CALENDAR.invalidTooltipMessages.tooLong');
        default:
          return false
      }
    }
  }
}
</script>

